import React, { useId } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';

import Fieldset from '@rover/components/src/formFields/Fieldset';
import SingleSelectButtonGroup from '@rover/components/src/formFields/SingleSelectButtonGroup';
import FilterLabel from '@rover/shared/js/search/components/FilterLabel';

import { TogglePreference } from '..';

type Props = {
  displayAsToggle?: boolean;
  onChange: (arg0: boolean) => void;
  value?: boolean;
};

const Pets = ({ displayAsToggle, onChange, value = false }: Props): JSX.Element => {
  const { t } = useLingui();
  const id = useId();

  const PUPPY_PREFERENCES_OPTIONS = [
    {
      value: true,
      title: t`Puppy (less than 1 year)`,
    },
    {
      value: false,
      title: t`Adult`,
    },
  ];

  return displayAsToggle ? (
    <TogglePreference
      label={t`I have a puppy younger than one year old`}
      onChange={onChange}
      value={value}
    />
  ) : (
    <Fieldset aria-labelledby={id}>
      <FilterLabel id={id}>
        <Trans>How old are your dogs?</Trans>
      </FilterLabel>
      <SingleSelectButtonGroup
        buttons={PUPPY_PREFERENCES_OPTIONS}
        id={id}
        onChange={onChange}
        value={value}
      />
    </Fieldset>
  );
};
export default Pets;
